import { IncludedModuleInfo as BackendIncludedModuleInfo } from "@longtail-education/superprepstudy-data-model-frontend"
//import { environment } from "@nx-superprep/environment"

/**
 * Represents an included module info.
 * Extends the BackendIncludedModuleInfo class from the backend data model.
 */
export class IncludedModuleInfo extends BackendIncludedModuleInfo {
  isFinished = false
  state = ""

  /** Overrides the converter property. */
  static override converter = {
    /**
     * Converts included module info data to Firestore format.
     * @param data The included module info data.
     * @returns The Firestore representation of the included module info data.
     */
    toFirestore: BackendIncludedModuleInfo.converter.toFirestore,
    /* alternative for the above method when dev/prod data model differ
    toFirestore(data: IncludedModuleInfo) {
      const obj = BackendIncludedModuleInfo.converter.toFirestore(data)
      if (environment.config.isProduction) { delete obj['isAssigned'] }
      return obj
    },
    */
    fromFirestore: BackendIncludedModuleInfo.converter.fromFirestore
  }
}
